export default {
    data() {
        return {
            activePerson: 0,
        };
    },
    methods: {
        setActivePerson(index) {
            this.activePerson = index;
        },

        isActivePerson(index) {
            return this.activePerson == index;
        },

        nameFilled(person) {
            return person.firstname || person.lastname;
        },

        hasAnyErrors(fieldName, index) {
            for(let errorKey in this.errors){
                if(errorKey.startsWith(`${fieldName}.${index}`))
                    return true;
            }

            return false;
        }
    }
}